<template>
  <v-container class="pa-0 pages">
    <v-layout row wrap ref="content" style="padding-bottom: 0">
      <v-flex xs12>
        <PageText :text="text"></PageText>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import PageText from "../components/PageText";
import { mapState, mapGetters } from "vuex";

export default {
  components: {
    PageText
  },
  props: ["identifier"],
  created() {
    this.fetchPageText();
  },
  watch: {
    $route: "fetchPageText"
  },
  computed: mapGetters("text", ["getText"]),
  data() {
    return {
      text: {}
    };
  },
  methods: {
    fetchPageText() {
      this.$store.dispatch("text/fetchTexts").then(() => {
        this.text = this.getText(this.identifier);
      });
    }
  }
};
</script>
